import { Box, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
	getModificationPriorTableRows,
	getModificationTableLayout,
	getMixedWeeklyModificationColumns,
} from "./quotaModificationUtils";
import {
   Button,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextareaAutosize, IconButton, useMediaQuery,
} from '@mui/material';
import CommentIcon from '@mui/icons-material/Comment';
import { useTheme } from "@mui/material/styles";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import CollapseSection from "../../../components/ui/CollapseSection";

const DisplayComments = (params) => {
   const [displayComments, setDisplayComments] = useState("");
   const [userComments, setUserComments] = useState("");
   const [open, setOpen] = useState(false);
   const desiredcolor =
       params?.comments?.length > 0 &&
           params?.comments != "Default Customer quota record"
           ? "blue"
           : "black";

   const theme = useTheme();
   const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

   const handleClose = () => {
       setOpen(false);
   };

   return (
       <>
           <IconButton
               onClick={() => setOpen(true)}
               title={params.comments}
           >
               {params?.comments ? (
                   <ForumOutlinedIcon title={params.comments} sx={{ color:"darkred.light" }}/>
               ) : (
                   <ForumOutlinedIcon />
               )}
           </IconButton>

           <Dialog
               disableEnforceFocus
               fullScreen={fullScreen}
               open={open}
               onClose={handleClose}
               aria-labelledby="responsive-dialog-title"
           >
               <DialogTitle id="responsive-dialog-title">Comments</DialogTitle>
               <DialogContent>
                   <DialogContentText>
                       <TextareaAutosize
                           onChange={(event) => setUserComments(event.target.value)}
                           aria-label="minimum height"
                           minRows={5}
                           readOnly
                           placeholder=""
                           style={{ width: 500, fontSize: 18 }}
                           defaultValue={params.comments}
                       />
                   </DialogContentText>
               </DialogContent>
               <DialogActions>
                   <Button
                       variant="outlined"
                       onClick={handleClose}
                       size="small"
                       sx={{
                        bgcolor: "darkred.light",
                        color: "white.main",
                        textTransform: "none",
                        fontWeight: "bold",
                        "&:hover": {
                          bgcolor: "darkred.main",
                          color: "white.main",
                        },
                      }}
                   >
                       Cancel
                   </Button>
               </DialogActions>
           </Dialog>
       </>
   );
};
function getModificationPriorTableCols(layout, depletionPeriodType) {
   const w = 150;
   if(layout === "none" ){
   const columns = [
      { field: "modificationNo", headerName: "Modification No",flex:1 },
      { field: "customerName", headerName: "Customer/CG", flex:1 },
      { field: "number", headerName: "Customer Number", flex:1 },
      { field: "skuName", headerName: "SKU", flex:1 },
      { field: "skuNumb", headerName: "SKU Number",flex:1 },
      {
         field: "depletionModelName",
         headerName: "Depletion Type",
         flex: 1,
         valueGetter: (params) =>
            params.row.depletionModelName ?? params.row.DepletionModelName ?? "",
      },
      { field: "modification1", headerName: "Quota", flex:1,
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString('en-US');
            return formattedValue;
         } },
      { field: "modificationComments", headerName: "Comments",flex:1 ,
      renderCell: (cellValues) => {
         return <DisplayComments readonly comments={cellValues.value} />;
      },},
   ];
   return columns;
   }else if(layout === "biweekly" ){
   const columns = [
      { field: "modificationNo", headerName: "Modification No", flex:1 },
      { field: "customerName", headerName: "Customer/CG", flex:1 },
      { field: "number", headerName: "Customer Number", flex:1 },
      { field: "skuName", headerName: "SKU", flex:1 },
      { field: "skuNumb", headerName: "SKU Number", flex:1 },
      {
         field: "depletionModelName",
         headerName: "Depletion Type",
         flex: 1,
         valueGetter: (params) =>
            params.row.depletionModelName ?? params.row.DepletionModelName ?? "",
      },
      { field: "modification1", headerName: "First Half", flex:1,
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString('en-US');
            return formattedValue;
         } },
      { field: "modification2", headerName: "Second Half", flex:1,
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString('en-US');
            return formattedValue;
         } },
      { field: "modificationComments", headerName: "Comments", flex:1 ,
      renderCell: (cellValues) => {
         return <DisplayComments readonly comments={cellValues.value} />;
      },},
   ];
   return columns;
   }
   const columns = [
      ...getMixedWeeklyModificationColumns(depletionPeriodType),
      {
         field: "modificationComments",
         headerName: "Comments",
         flex: 1,
         renderCell: (cellValues) => {
            return <DisplayComments readonly comments={cellValues.value} />;
         },
      },
   ];
   return columns;
  
}

export default function ModificationPriorTable() {
   const state = useSelector((store) => store.quotaModification);
   const { scenarioModificationList,modificationCustomersPriorChanges,
      modificationCustomersLatestChanges, selectedRows, displayModifiedRecords,scenarioName, selectedModificationNumber, periodType } = state;

   const [paginationModel, setPaginationModel] = useState({
      pageSize: 20,
      page: 0,
   });

   if(scenarioModificationList === null) return null;

   // const rows = getModificationPriorTableRows(
   //    scenarioModificationList[selectedRows[selectedRows.length - 1]].modificationCustomersPriorChanges,
   //    scenarioModificationList[selectedRows[selectedRows.length - 1]].modificationCustomersLatestChanges,
   //    displayModifiedRecords
   // );
   let modificationNo = ""
   if(selectedModificationNumber === null || selectedModificationNumber === undefined ||selectedModificationNumber === ""){
      modificationNo = scenarioModificationList[0].modificationNo 
   }else{
      modificationNo = selectedModificationNumber;
   }
   const rows = getModificationPriorTableRows(
      modificationCustomersPriorChanges,
      modificationCustomersLatestChanges,
      displayModifiedRecords, modificationNo
   );
   const depletionPeriodType =
      scenarioModificationList[0]?.depletionPeriodType ??
      scenarioModificationList[0]?.DepletionPeriodType ??
      "";
   const isWeeklyPeriodType =
      (
         periodType ??
         ""
      )
         .trim()
         .toLowerCase() === "weekly";
   const columns = getModificationPriorTableCols(
      getModificationTableLayout(rows),
      depletionPeriodType
   ).filter(
      (col) => !(isWeeklyPeriodType && col.field === "depletionModelName")
   );
   const title = `Quota of : ${scenarioName}`

   return (
      <Box sx={{ mt: 3 }}>
         {/* <div>
            <Typography className="compHeading" sx={{mb: 2, mt: 4,fontWeight:600, }}>Quota of: {scenarioName}</Typography>
         </div> */}
         <CollapseSection title={title}>
         <DataGrid style={{ maxHeight: 'calc(100vh - 130px)'}}
            rows={rows}
            columns={columns}
            disableColumnMenu
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[20, 50, 100]}
            headerHeight={40} 
         />
         </CollapseSection>
      </Box>
   );
}
